/* Store Builder theme. No cart: Buy empties the cart, adds the chosen bundle and opens the checkout. */
(function () {
  'use strict';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* Gallery: thumbnails scroll the track, the track updates the active thumbnail. */
  function initGallery(gallery) {
    var track = $('[data-gallery-track]', gallery);
    var thumbs = $$('[data-thumb]', gallery);
    if (!track || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var i = Number(thumb.getAttribute('data-thumb'));
        track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
      });
    });
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
        var active = thumbs[i];
        if (active && active.parentElement) {
          var p = active.parentElement;
          var left = active.offsetLeft - p.clientWidth / 2 + active.clientWidth / 2;
          p.scrollTo({ left: left, behavior: 'smooth' });
        }
        ticking = false;
      });
    }, { passive: true });
  }

  /* Offer picker + Buy. */
  function initProduct(section) {
    var dataEl = $('[data-product-json]', section);
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var form = $('[data-offer]', section);
    var buyBtn = $('[data-buy]', section);
    var buyTotal = $('[data-buy-total]', section);
    var errorEl = $('[data-error]', section);
    var sticky = $('[data-sticky-buy]', section);
    var stickyTotal = $('[data-sticky-total]', section);
    var stickyGo = $('[data-sticky-go]', section);
    var units = $$('[data-unit]', section);
    var busy = false;

    function bundleSize() {
      var checked = $('input[name="bundle"]:checked', form);
      return checked ? Number(checked.value) : 1;
    }

    function update() {
      var n = bundleSize();
      units.forEach(function (u) { u.hidden = Number(u.getAttribute('data-unit')) > n; });
      var totalEl = $('[data-offer-total="' + n + '"]', form);
      var text = totalEl ? totalEl.textContent.trim() : '';
      if (buyTotal) buyTotal.textContent = text;
      if (stickyTotal) stickyTotal.textContent = text;
      hideError();
    }

    function showError(msg) { if (!errorEl) return; errorEl.textContent = msg; errorEl.hidden = false; }
    function hideError() { if (!errorEl) return; errorEl.hidden = true; errorEl.textContent = ''; $$('.is-missing', section).forEach(function (el) { el.classList.remove('is-missing'); }); }

    function findVariant(color, size) {
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i];
        var ok = true;
        if (data.colorPos > 0 && v.options[data.colorPos - 1] !== color) ok = false;
        if (data.sizePos > 0 && v.options[data.sizePos - 1] !== size) ok = false;
        if (ok) return v;
      }
      return null;
    }

    /* Returns the cart lines, or null after showing what is missing. */
    function collect() {
      hideError();
      var n = bundleSize();
      var lines = {};
      var firstMissing = null;
      for (var k = 1; k <= n; k++) {
        var unit = $('[data-unit="' + k + '"]', section);
        var colorInput = $('input[name="color-' + k + '"]:checked', unit);
        var sizeSelect = $('select[name="size-' + k + '"]', unit);
        var color = colorInput ? colorInput.value : null;
        var size = sizeSelect ? sizeSelect.value : null;
        if (sizeSelect && !size) {
          sizeSelect.classList.add('is-missing');
          if (!firstMissing) firstMissing = sizeSelect;
          continue;
        }
        var v = findVariant(color, size);
        if (!v) { showError('That combination is not available. Please choose another.'); return null; }
        if (!v.available) { showError((color ? color + ' ' : '') + (size || '') + ' is sold out. Please choose another.'); return null; }
        lines[v.id] = (lines[v.id] || 0) + 1;
      }
      if (firstMissing) {
        showError(n > 1 ? 'Please choose a size for each one.' : 'Please choose your size.');
        firstMissing.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () { firstMissing.focus({ preventScroll: true }); }, 350);
        return null;
      }
      return Object.keys(lines).map(function (id) { return { id: Number(id), quantity: lines[id] }; });
    }

    function permalink(items) {
      return data.root + 'cart/' + items.map(function (i) { return i.id + ':' + i.quantity; }).join(',');
    }

    function buy() {
      if (busy) return;
      var items = collect();
      if (!items) return;
      busy = true;
      if (buyBtn) buyBtn.setAttribute('disabled', '');
      if (stickyGo) stickyGo.setAttribute('disabled', '');
      var json = { 'Content-Type': 'application/json', Accept: 'application/json' };
      fetch(data.root + 'cart/clear.js', { method: 'POST', headers: json, body: '{}' })
        .then(function () {
          return fetch(data.root + 'cart/add.js', { method: 'POST', headers: json, body: JSON.stringify({ items: items }) });
        })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (body) { throw new Error(body && body.description ? body.description : 'add failed'); });
          window.location.href = data.root + 'checkout';
        })
        .catch(function (err) {
          /* Fallback: a cart permalink opens the checkout with the same items. */
          if (err && /sold out|not available|quantity/i.test(err.message)) {
            showError(err.message);
            busy = false;
            if (buyBtn) buyBtn.removeAttribute('disabled');
            if (stickyGo) stickyGo.removeAttribute('disabled');
            return;
          }
          window.location.href = permalink(items);
        });
    }

    form.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'bundle') update();
      if (e.target && e.target.matches('select[data-size]') && e.target.value) e.target.classList.remove('is-missing');
    });
    if (buyBtn) buyBtn.addEventListener('click', buy);
    if (stickyGo) stickyGo.addEventListener('click', function () {
      var n = bundleSize();
      var missing = false;
      for (var k = 1; k <= n; k++) {
        var s = $('select[name="size-' + k + '"]', section);
        if (s && !s.value) missing = true;
      }
      if (missing) {
        var target = $('[data-units]', section) || form;
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        collect();
      } else {
        buy();
      }
    });

    /* Back/forward cache: re-enable the button when the page is shown again. */
    window.addEventListener('pageshow', function () {
      busy = false;
      if (buyBtn) buyBtn.removeAttribute('disabled');
      if (stickyGo) stickyGo.removeAttribute('disabled');
    });

    /* Sticky bar: visible once the buy button has scrolled out of view above. */
    if (sticky && buyBtn && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var above = entry.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', !entry.isIntersecting && above);
        });
      }, { threshold: 0 });
      io.observe(buyBtn);
    }

    update();
  }

  /* Dialogs (size guide). */
  function initDialogs() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-open-dialog]');
      if (opener) {
        var d = document.getElementById(opener.getAttribute('data-open-dialog'));
        if (d && d.showModal) { d.showModal(); }
        return;
      }
      var closer = e.target.closest('[data-close-dialog]');
      if (closer) {
        var dlg = closer.closest('dialog');
        if (dlg) dlg.close();
        return;
      }
      if (e.target.tagName === 'DIALOG') {
        var r = e.target.getBoundingClientRect();
        var inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
        if (!inside) e.target.close();
      }
    });
  }

  /* Country / currency selector submits on change. */
  function initLocalization() {
    $$('[data-autosubmit]').forEach(function (el) {
      el.addEventListener('change', function () { if (el.form) el.form.submit(); });
    });
  }

  function init() {
    $$('[data-gallery]').forEach(initGallery);
    $$('[data-product-section]').forEach(initProduct);
    initDialogs();
    initLocalization();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
